class WallAreaCalculator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.querySelector('form').addEventListener('submit', (event) => {
      event.preventDefault();
      const width = Number(this.querySelector('[name="width"]').value);
      const height = Number(this.querySelector('[name="height"]').value);
      const result = this.querySelector('[role="status"]');
      if (!Number.isFinite(width) || !Number.isFinite(height) || width < 0.1 || height < 0.1 || width > 100 || height > 100) {
        result.textContent = this.dataset.invalid;
        return;
      }
      const area = new Intl.NumberFormat('he-IL', {maximumFractionDigits: 2}).format(width * height);
      result.textContent = `${this.dataset.label}: ${area} ${this.dataset.unit}`;
      this.querySelector('[data-quote]').href = `https://wa.me/972509445045?text=${encodeURIComponent(`${this.dataset.message} ${width} × ${height}. ${result.textContent}`)}`;
    });
  }
}
if (!customElements.get('wall-area-calculator')) customElements.define('wall-area-calculator', WallAreaCalculator);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.studio-header details[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.studio-header details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});

document.addEventListener('click', (event) => {
 const link=event.target.closest('.hermes-buy-whatsapp');
 if(!link) return;
 const scope=link.closest('product-info');
 const count=scope?.querySelector('.quantity__input')?.value || '1';
 const options=[...(scope?.querySelectorAll('variant-selects select') || [])].map(select=>select.selectedOptions[0]?.textContent.trim()).filter(Boolean);
 const url=new URL(link.href);
 const base=new URL(location.href);
 base.searchParams.delete('preview_theme_id');
 url.searchParams.set('text',[link.dataset.productTitle,options.join(' / '),`× ${count}`,base.toString()].filter(Boolean).join('\n'));
 link.href=url.toString();
});
